/**
 * Created by zulqernain on 11/04/19.
 */
import React from 'react'
import '../../../node_modules/react-dropzone-component/styles/filepicker.css'
import '../../../node_modules/dropzone/dist/min/dropzone.min.css'
import DropzoneComponent from 'react-dropzone-component';

import AuthToken from '../../Token'
import {
   API_DOMAIN_URL, API_SECTION_LISTINGS, API_ENDPOINT_IMAGES_UPLOAD,
  API_ENDPOINT_DOCUMENT_UPLOAD_REQ, API_SECTION_REQUIREMENTS
} from '../../Constants'

var componentConfigForImages = {
    iconFiletypes: ['.jpg', '.png', '.gif'],
    showFiletypeIcon: true,
    postUrl: `${API_DOMAIN_URL}${API_SECTION_LISTINGS}${API_ENDPOINT_IMAGES_UPLOAD}`
    // process.env.RAZZLE_API_IMAGE_UPLOAD,

};
var componentConfigForDocuments = {
    iconFiletypes: ['.img', '.pdf', '.doc', '.xls'],
    showFiletypeIcon: true,
    postUrl: `${API_DOMAIN_URL}${API_SECTION_LISTINGS}${API_ENDPOINT_DOCUMENT_UPLOAD_REQ}`
    // process.env.RAZZLE_API_DOCUMENT_UPLOAD,

};

var componentConfigForDocumentVerifcation = {
    iconFiletypes: [],
    showFiletypeIcon: true,
    postUrl: 'no-url'
}

export default class Drag_n_Drop extends React.Component {
    constructor(props) {
        console.log("hihi")
        super(props)
        this.state = {
          files: {},
          documents: {},
          showError: false
        }
        this.onUploadSuccess = this.onUploadSuccess.bind(this);
        this.onDocumentUploadSuccess = this.onDocumentUploadSuccess.bind(this);
    }


    addedFile(file) {
        console.log('dnd Drag_n_Drop addedFile ', file);
        var self = this
        var files = self.state.files
        files[file.name] = file
        console.log('dnd Drag_n_Drop addedFile final ', files);
        self.setState({files})

        if ((self.props.file_type == "documents" || self.props.file_type == "images&pdf") && self.props.formType == "docVerify") {
            if(this.props.onDndDocChange) this.props.onDndDocChange(file);
        }
        if(this.props.addedFile){
            if(self.props.noOffFileLimit){
              if(Object.keys(this.state.files).length <= self.props.noOffFileLimit)
              this.props.addedFile(file);
            }
            else{
              this.props.addedFile(file);
            }
        } 
  
    }

    removedfile(file) {
        console.log('dnd Drag_n_Drop removedfile ', file);
        var self = this
        var files = self.state.files
        delete files[file.name]
        self.setState({files})
        console.log('dnd Drag_n_Drop removedfile final ', files);
        if(this.props.onDndFileChange) this.props.onDndFileChange(files)

    }

    removedDocument(file) {
        var self = this
        var documents = self.state.documents
        delete documents[file.name]
        self.setState({documents})
        if(this.props.onDndDocChange) this.props.onDndDocChange(documents);

    }

    onUploadSuccess(file, response, error) {
        console.log('dnd Drag_n_Drop onUploadSuccess ', file);
        var self = this
        var files = self.state.files
        file.id = response.id
        files[file.name] = file


        for (var key in files) {
            console.log('dnd Drag_n_Drop onUploadSuccess file key', files[key].id);
        }
        console.log('dnd Drag_n_Drop onUploadSuccess final ', files);
        self.setState({files})
        if(this.props.onDndFileChange) this.props.onDndFileChange(files)
    }

    onDocumentUploadSuccess(file, response, error) {
        var self = this
        var documents = self.state.documents
        file.id = response.id
        documents[file.name] = file


        for (var key in documents) {
            console.log(documents[key].id);
        }

        self.setState({documents})
        if(this.props.onDndDocChange) this.props.onDndDocChange(documents);
    }

    onMaxfilesexceeded = (file) => {
      this.setState({showError: true})
    }
    
    render() {
        var self = this
        var eventHandlers = {
            success: this.onUploadSuccess,
            addedfile: this.addedFile.bind(this),
            removedfile: this.removedfile.bind(this)
        }
        if(self.props.file_type == "documents" ){
            eventHandlers.success = this.onDocumentUploadSuccess;
            eventHandlers.removedfile = this.removedDocument.bind(this);
        }
        if (self.props.file_type === "images&pdf") {
            eventHandlers.success = this.onDocumentUploadSuccess;
            eventHandlers.removedfile = this.removedDocument.bind(this);
        }
        // if(self.props.formType == "newRequirement" && self.props.file_type == "documents") {
        //   eventHandlers.maxfilesexceeded = this.onMaxfilesexceeded;
        // }
        console.log('dnd Drag_n_Drop Drag_n_Drop render ', self.state);
        var acceptedFiles = "image/*"
        var componentConfig = componentConfigForImages
        
        if(self.props.file_type == "documents" ){
          acceptedFiles = "image/*,application/pdf,.docx,.doc,.xlsx,.xls,.csv;"
          if(self.props.formType=="newRequirement") {
            componentConfigForDocuments['postUrl'] = `${API_DOMAIN_URL}${API_SECTION_REQUIREMENTS}${API_ENDPOINT_DOCUMENT_UPLOAD_REQ}`;
          } else if(self.props.formType=="remittance") {
            componentConfigForDocuments['postUrl'] = self.props.postUrl || null;
            console.log('remitt dnd componentConfigForDocuments', componentConfigForDocuments)
          }

          // process.env.RAZZLE_API_DOCUMENT_UPLOAD_REQUIREMENTS
          componentConfig = componentConfigForDocuments
        } else if(self.props.file_type == "documents" ){
            acceptedFiles = "application/pdf,.docx,.doc,.xlsx,.xls;"
            componentConfig = componentConfigForDocuments
        } else if (self.props.file_type === "images&pdf") {
            acceptedFiles = "application/pdf,image/*"
            componentConfig = componentConfigForDocumentVerifcation
        }


        var djsConfig = {

            addRemoveLinks: true,
            params: {
                position: Object.keys(this.state.files).length
            },
            headers: {
                'Authorization': "Bearer " + AuthToken.getToken(AuthToken.ACCESS_TOKEN),
                'source': 'website',
                "Cache-Control": "",


            },
            acceptedFiles: acceptedFiles,

        }
         if(self.props.autoUpload == false) {
          djsConfig['headers'] = {};
          djsConfig['autoProcessQueue'] = false;
          djsConfig['autoQueue'] = false
        }
        if(self.props.formType == "crm_upload" && self.props.file_type == "images") {
            eventHandlers.maxfilesexceeded = this.onMaxfilesexceeded;
            // delete componentConfig.postUrl;
            if(self.props.postUrl) componentConfigForImages.postUrl = self.props.postUrl
            else componentConfigForImages.postUrl = 'no-url';
            componentConfig = componentConfigForImages
  
            djsConfig['params'] = self.props.postParam
        }
        if(this.props.postParams) djsConfig["params"] = this.props.postParams;
        if(this.props.defaultMsg) djsConfig["dictDefaultMessage"] = this.props.defaultMsg;
        if (self.props.file_type === "images&pdf" && self.props.formType === "docVerify") {
            eventHandlers.maxfilesexceeded = this.onMaxfilesexceeded;
            djsConfig['headers'] = {};
            djsConfig['autoProcessQueue'] = false;
            djsConfig['autoQueue'] = false
        }
        // if(self.props.formType == 'newRequirement' && self.props.file_type == 'documents') djsConfig.maxFiles = 1
        console.log('remitt dnd djsConfig ', djsConfig, this.props.postParams, this.props)
        if(self.props.noOffFileLimit) djsConfig.maxFiles = self.props.noOffFileLimit
        return <div style={{color:'black'}}>
          <DropzoneComponent config={componentConfig} eventHandlers={eventHandlers} djsConfig={djsConfig}/>
          {self.state.showError && (<label style={{color: 'red'}}>{self.props.errorMsg || 'Please Upload only 1 file! We will use only the latest file.'}</label>)}
        </div>
    }
}
